<!--
 * @Author:yeqing
 * @Date: 2021-11-24 10:30:57
 * @LastEditTime: 2022-05-13 16:32:08
 * @LastEditors: yeqing
 * @Description: 特新能力测评组件
 * @FilePath: \fe-frame-page\src\views\enterpriseSpecial\smEvaluation\components\specialNewModel.vue
-->
<template>
  <div class="specialNewModel">
    <a-form>
      <a-form-item label="1、企业品牌特色化情况：" class="block">
        <a-checkbox-group
          name="checkboxgroup"
          :value="awardList"
          :options="awardOptions"
          @change="onChangeAward"
        ></a-checkbox-group>
      </a-form-item>
      <div class="input-box">
        2、企业累计拥有授权专利总数量：<a-input
          :value="specialNew.q432[0]"
          @change="formatNumber($event, 0)"
        ></a-input
        >个， 其中，外观设计数量：
        <a-input
          :value="specialNew.q432[1]"
          @change="formatNumber($event, 1)"
        ></a-input
        >个， 实用新型数量：<a-input
          :value="specialNew.q432[2]"
          @change="formatNumber($event, 2)"
        ></a-input
        >个， 发明专利技术数量：<a-input
          :value="specialNew.q432[3]"
          @change="formatNumber($event, 3)"
        ></a-input>
        个，软件著作产权数量：<a-input
          :value="specialNew.q432[4]"
          @change="formatNumber($event, 4)"
        ></a-input>
        个， 其他数量：<a-input
          :value="specialNew.q432[5]"
          @change="formatNumber($event, 5)"
        ></a-input
        >个<span>（企业专利数为必填项，暂无可填“0”）</span>
      </div>
      <a-form-item
        label="3、企业是否开展技术创新、管理创新和商业模式创新，培育新的增长点，形成新的竞争优势"
      >
        <a-radio-group name="radioGroup" v-model="specialNew.q433">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="4、近二年的研发投入支出是否占主营业务收入的比重≥2%">
        <a-radio-group name="radioGroup" v-model="specialNew.q434">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="5、企业近两年研发经费支出占营业收入的比重均不低于5%">
        <a-radio-group name="radioGroup" v-model="specialNew.q435">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="6、企业上年度主营业务收入1000万元以上">
        <a-radio-group name="radioGroup" v-model="specialNew.q436">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="7、企业申报前两年主营业务收入同比正增长">
        <a-radio-group name="radioGroup" v-model="specialNew.q437">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="8、申报前两年主营业务收入年均增长不低于10%"
        v-if="isShow"
      >
        <a-radio-group name="radioGroup" v-model="specialNew.q438">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="9、上一年度缴纳社保月均员工数不少于30人"
        v-if="isShow"
      >
        <a-radio-group name="radioGroup" v-model="specialNew.q439">
          <a-radio value="是">是</a-radio>
          <a-radio value="否">否</a-radio>
        </a-radio-group>
      </a-form-item>
      <div style="text-align: center; margin-top: 40px;">
        <a-button class="primary-btn pre-btn" @click="handlePre"
          >上一步</a-button
        >
        <a-button
          type="primary"
          class="primary-btn"
          @click="handleSubmit"
          :loading="loading"
          >获取报告</a-button
        >
      </div>
    </a-form>
  </div>
</template>

<script>
export default {
  name: "specialNewModel",
  props: {
    loading: Boolean,
    isShow: Boolean,
  },
  data() {
    return {
      specialNew: {
        q431: "",
        q432: ["", "", "", "", "", ""],
        q433: "",
        q434: "",
        q435: "",
        q436: "",
        q437: "",
        q438: "",
        q439: "",
      },
      awardOptions: [
        "掌握独有、可持续的工艺、技术、配方，有自主知识产权和特色品牌",
        "属于有效期内的“中华老字号”、驰名商标、省级以上名牌产品",
        "是经权威部门认定的专有技术",
        "企业暂未获得企业品牌荣誉",
      ],
      awardList: [],
    };
  },
  methods: {

    onChangeAward(e){
      if(e.length > 1 && e.findIndex(item=>item == '企业暂未获得企业品牌荣誉') !=-1){
         this.$message.warn("您的多选项有冲突，请重新选择。");
         return
      }
      this.awardList = e
    },
    formatNumber(e, tag) {
      tag = Number(tag);
      const { value } = e.target;
      const reg = /^-?[0-9]\d*$/;
      let list = JSON.parse(JSON.stringify(this.specialNew.q432));
      if (!value) {
        list[tag] = "";
      }
      if (reg.test(value)) {
        list[tag] = Number(value);
      }
      this.specialNew.q432 = list;
    },
    // 上一步
    handlePre(e) {
      e.preventDefault();
      this.$emit("changeTabKey", {
        name: "specialNew",
        key: 2,
        data: this.specialNew,
      });
    },

    // 立即测评
    handleSubmit(e) {
      e.preventDefault();
      const { q432 } = this.specialNew;
      this.specialNew.q431 = this.awardList.join(",");
      let data = {};
      if (this.isShow) {
        data = this.specialNew;
      } else {
        data = {
          q431: this.specialNew.q431,
          q432: this.specialNew.q432,
          q433: this.specialNew.q433,
          q434: this.specialNew.q434,
          q435: this.specialNew.q435,
          q436: this.specialNew.q436,
          q437: this.specialNew.q437,
        };
      }
      if (q432.findIndex((item) => item === "") == -1) {
        this.$emit("handleSubmit", data);
      } else {
        this.$message.error("您有未填写的企业信息，请补全完成");
      }
    },
  },
};
</script>
<style lang="less" scoped>
.specialNewModel {
  margin-top: 30px;
  .input-box {
    margin: 0;
    padding: 0 0 8px;
    line-height: 39.9999px;
    white-space: initial;
    text-align: left;
    color: #333333;
    margin-right: 6px;
    font-size: 14px;
    input {
      margin-right: 10px;
      width: 100px;
    }
    >span{
      color: #888;
    }
  }
}
</style>
